export default __webpack_public_path__ + "static/media/misc-books3-2048w.f2af58fd.webp";